import { useState, useEffect } from "react";
import { useUserDataContext } from '../../contexts/userDataProvider';
import { usePropertyContext } from '../../contexts/propertyProvider';
import { Button } from "react-materialize";
import { GrMenu, GrAdd } from 'react-icons/gr';
import { FloatButton } from 'antd';
import ordersAPI from '../../services/ordersAPI';
import { useFetch } from '../common/requests.hooks';
import M from 'materialize-css';
import { getObjectByValue } from '../common/utils';
import {
  parseGroupForTimeline,
  parseOrdersForTimeline,
} from './timeLineUtils';
import TimelineFilters from './TimelineFilters';
import Loader from '../common/Loader';
import ErrorAlert from '../common/ErrorAlert';
import ModalComponent from '../common/ModalComponent';
import OrderView from "./addEditOrder/OrderView";
import TimeLine from "./TimeLine";

const TimeLineView = () => {
  const [groupForTimeline, setGroupForTimeline] = useState([]);
  const [ordersForTimeLine, setOrdersForTimeLine] = useState([]);
  const [selectedDate, setSelectedDate] = useState({}); 
  const [isModal, setIsModal] = useState(false);
  const [itemData, setItemData] = useState({
    isTimeLineEditOrder: false,
    isTimeLineNewOrder: false,
    // propertyName: undefined,
    // clickedDate: undefined
  });
  const [warning, setWarning] = useState(null);

  const {
    data: propertyData,
    isLoading: isPropertyLoading,
    error: errorProperty
  } = usePropertyContext([]);

  const {
    translate,
    isLoading: isUserDataLoading,
    error: userDataError,
  } = useUserDataContext();

  const {
    data: orders,
    isLoading: isOrderLoading,
    error: errorOrder,
    reloadData: reloadOrderData
  } = useFetch(
    ordersAPI.getOrders,
    {
      key: ['orders', selectedDate],
      enabled: Boolean(selectedDate && selectedDate.dateFrom && Object.keys(selectedDate).length > 0)
    },
    { selectedDate: selectedDate }
  );

  // Display the popup warning
  const displayToast = (message) => {
    M.toast({ html: message, displayLength: 5000 });
  };

  const closeEditModalReloadData = () => {
    setIsModal(false);
    reloadOrderData();
  };

  useEffect(() => {
    if (!Array.isArray(orders) || !propertyData?.length) {
      return;
    }

    const parsedOrders = parseOrdersForTimeline(orders);

    setOrdersForTimeLine(parsedOrders);
    setGroupForTimeline(parseGroupForTimeline(propertyData));
  }, [orders, propertyData]);

  useEffect(() => {
    if (warning) {
      displayToast(warning);
      setWarning(null);
    }
  }, [warning]);

  const isCombinedLoading =
  isOrderLoading ||
  isPropertyLoading ||
  isUserDataLoading;

  if (!propertyData?.length && !isCombinedLoading) {
    return (
      <div className="timeline-noGroupExists-wrap">
        <p>{translate('addFirstPropertyInSettings')}</p>
        <GrMenu className="menu-button" />
      </div>
    )
  }

  const isGroupDisables = (propertyId) => {
    const selectedGroupData = getObjectByValue(propertyData, 'id', propertyId);

    return selectedGroupData && !selectedGroupData.isAvailable;
  };

  const itemClickHandler = (item) => {
      if (isGroupDisables(item.propertyId)) {
        return;
      }
      setItemData({
        isTimeLineEditOrder: true,
        orderId: item.id,
        propertyName: item.group,
        propertyId: item.propertyId,
        dateFrom: item.start.toISOString(),
        dateTo: item.end.toISOString(),
        firstName: item.firstName,
        surname: item.surname,
        costPerNight: item.costPerNight,
        totalCost: item.totalCost,
        email: item.email,
        phone: item.phone,
        feeding: item.feeding,
        description: item.description,
        status: item.status
      });

      setIsModal(true);
  };

  const backgroundClickHandler = (timeLineGroupRow) => {

      if (isGroupDisables(timeLineGroupRow.propertyId)) {
        return;
      }
      // use "selectedGroupData &&" check to separate Disabled group from Newly created group.
      // Case - Create New group -> click timeline on this group.
      // For newly creaded group click, without window reload, "selectedGroupData" is null because "propertyData" is not updating.
      setItemData({
        isTimeLineNewOrder: true,
        propertyName: timeLineGroupRow.group,
        clickedDate: timeLineGroupRow.time
      });
      setIsModal(true);
  };

  const addNewOrderButton = () => {
    backgroundClickHandler({
      group: propertyData[0].title,
      time: new Date()
    });
  };

  return (
    <div className="timeline-view-wrap">
      <Loader 
        setIsLoading={isCombinedLoading}
      />
      <ErrorAlert
        error={errorOrder || errorProperty || userDataError}
      />
      <ModalComponent 
        ModalContent={
          <OrderView
            clickedItemData={itemData}
            closeEditModalReloadData={closeEditModalReloadData}
            allOrders={orders}
            timeLineLoadedDataRange = {selectedDate}
          />
        }
        hideCancelButton
        show={isModal}
        handleClose={() => setIsModal(false)}
      />
      <TimelineFilters
        setSelectedDate={setSelectedDate} // Set X month range
      />
      <TimeLine
        options={{
          translate: translate
        }}
        items={ordersForTimeLine}
        groups={groupForTimeline}
        itemClickHandler={itemClickHandler}
        backgroundClickHandler={backgroundClickHandler}
        selectedDate={selectedDate}
      />
      <Button
        className="add-new-order-button"
        node="button"
        onClick={addNewOrderButton}
      >
        {translate('addReservation')}
      </Button>
      <FloatButton
        className="plus-button"
        onClick={addNewOrderButton}
        icon={<GrAdd />}
      />
    </div>
  );
};

export default TimeLineView;
